import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { CampaignThemeDto, CampaignThemeId } from 'app/client-core/dtos/campaigns.model';
import { ValidationMessage } from 'app/validation';
import { BsModalService } from 'ngx-bootstrap';
import { ProgramService } from 'app/client-core/services/program.service';
import { CampaignService } from 'app/client-core/services';
import { CampaignImagePreviewModalComponent } from './image-previwer/image-preview.modal.component';
import { LayoutService } from '../layout/layout.service';

const $ = jQuery;
@Component({
  selector: 'app-campaign-modal',
  templateUrl: './campaign-modal-component.component.html',
  styleUrls: ['./campaign-modal-component.component.scss']
})
export class CampaignModalComponent implements OnInit, OnChanges {
  activeTab = 'info';
  ready = false;
  @Input() selectedCampaignId: number;
  campaignThemeDto: CampaignThemeDto;
  validationMessages: any;
  fromCampaignProgramPage: boolean;
  private createPlanModalConfig = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "modal-lg"
  };

  constructor(
    private layoutService: LayoutService,
    private campaignService: CampaignService,
    private modalService: BsModalService,
    private programService: ProgramService
  ) { }

  ngOnInit() {
    if (this.selectedCampaignId) {
      this.loadCampaignTheme();
    }
  }

  ngOnChanges(changes) {
    this.fromCampaignProgramPage = location.href.indexOf('/campaign-library/') > -1;
    this.loadCampaignTheme();
  }

  closeModal() {
    this.layoutService.hideSideModal.next();
  }

  loadCampaignTheme(): void {
    this.ready = false;
    this.campaignService.getCampaignTheme(this.selectedCampaignId)
      .subscribe(res => {
        if (!res.hasError) {
          this.campaignThemeDto = res.data;
          this.ready = true;
          this.activeTab = 'info';
          window.scroll(0, 0);
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Campaign theme could not be retrieved");
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
        },
        () => {
        });
  }

  openImagePreview(path) {
    const initialState = { imagePath: path }
    // tslint:disable-next-line:max-line-length
    this.modalService.show(CampaignImagePreviewModalComponent, Object.assign({}, this.createPlanModalConfig, { initialState }));
  }

  select(): void {
    console.log('>>info.select', this.campaignThemeDto.id);
    let themeId = new CampaignThemeId(this.campaignThemeDto.id);
    const initialState = { selectedCampaignId: this.selectedCampaignId, hideStoreSelector: false }
    console.log(initialState);
    this.campaignService.getCampaignTheme(this.selectedCampaignId).subscribe(response => {
        if (response.data.campaignThemeTypeID == 2) {
            this.programService.createPrefilledProgram(response.data.id).subscribe(program_response => {
                this.programService.programCreated.next(program_response.data);
            });
            return;
        } else if (response.data.campaignThemeTypeID == 3) {
            initialState.hideStoreSelector = true;
        }
        this.layoutService.hideSideModal.next();
        // tslint:disable-next-line:max-line-length
        this.layoutService.showCreateCampaignThemeInfo.next({campaignId: this.campaignThemeDto.id, programId: null, fromMyCampaigns: false});
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/campaign-modal-component/campaign-modal-component.component.ts